import type { ReactNode } from "react";
import { Card } from "~/common/mui";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { OptionalPartsEntrySummary } from "./OptionalPartsEntrySummary";

interface OptionalPartEntryProps {
  descriptor: ProductDescriptor;
  editMode: boolean;
  children: ReactNode;
}

export const OptionalPartEntry = ({ descriptor, editMode, children }: OptionalPartEntryProps) => {
  return (
    <Card>
      <OptionalPartsEntrySummary product={descriptor} editMode={editMode} />
      {children}
    </Card>
  );
};
